import { atom } from 'jotai';

export const isTridionPreviewAtom = atom(false);
